export const styles = {
  input: {
    fontFamily: "Roboto",
    fontSize: 20,
    lineHeight: 1.15,
    color: "black.main",
  },
};
